import Box from '@mui/material/Box/Box'
import { roundingNumber } from 'components/shared/processes'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as NextIcon } from '../../assets/arrow_close_logo.svg'
import { IRationArray } from '../../models/IRationSystem'
import { COLORS } from '../../styles/colors'
import { CardStandart } from '../../ui/CardStandart'
import { TypographyHeader } from '../../ui/typography/TypographyHeader'
import { TypographyPrimary } from '../../ui/typography/TypographyPrimary'
import { TypographySecondary } from '../../ui/typography/TypographySecondary'
import { TypographySecondary14 } from '../../ui/typography/TypographySecondary14'
import ActiveComp from './utils/ActiveComp'

const RationCard = ({ rationArray }: { rationArray: IRationArray }) => {
	const navigate = useNavigate()
	const groupLabelArray = rationArray.groups.map(el => {
		return (
			<Box
				key={el.id}
				style={{
					fontSize: '14px',
					fontWeight: '400',
					padding: '8px 16px',
					background: '#f7f7f7',
					borderRadius: '12px',
					whiteSpace: 'nowrap',
				}}
			>
				{el.title}
			</Box>
		)
	})
	return (
		<Box
			sx={{ width: '100%', cursor: 'pointer' }}
			onClick={() => navigate(`/feed/ration/${rationArray.id}`)}
		>
			<CardStandart>
				<Box sx={{ padding: '24px', display: 'flex', flexDirection: 'column' }}>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								gap: '8px',
							}}
						>
							<TypographyHeader>{rationArray.title}</TypographyHeader>
							<ActiveComp is_archived={rationArray.is_archived}></ActiveComp>
						</Box>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								gap: '16px',
							}}
						>
							<TypographySecondary>
								Дата создания{' '}
								{moment(rationArray.created_at).format('DD.MM.YYYY')}
							</TypographySecondary>
							<NextIcon
								stroke={COLORS.icon}
								style={{ transform: 'rotate(-90deg)' }}
							/>
						</Box>
					</Box>
					<Box
						sx={{
							marginTop: '16px',
							display: 'flex',
							flexDirection: 'row',
							gap: '8px',
						}}
					>
						<TypographySecondary14>Сухое вещество:</TypographySecondary14>
						<TypographyPrimary>
							{roundingNumber(rationArray.dry_matter_total, 0)}{' '}
							<span style={{ color: COLORS.secondaryFont }}>%</span>
						</TypographyPrimary>
					</Box>
					<Box
						sx={{
							marginTop: '16px',
							display: 'flex',
							flexDirection: 'row',
							gap: '8px',
						}}
					>
						<TypographySecondary14>Влажность рациона:</TypographySecondary14>
						<TypographyPrimary>
							{roundingNumber(rationArray.food_humidity, 0)}{' '}
							<span style={{ color: COLORS.secondaryFont }}>%</span>
						</TypographyPrimary>
					</Box>
					<Box
						sx={{
							marginTop: '16px',
							display: 'flex',
							flexDirection: 'row',
							alignContent: 'center',
							gap: '8px',
						}}
					>
						{rationArray?.groups?.length !== 0 && (
							<>
								<TypographySecondary14
									sx={{ whiteSpace: 'nowrap', paddingTop: '8px' }}
								>
									Используется в группах:
								</TypographySecondary14>
								<Box
									sx={{
										display: 'flex',
										flexDirection: 'row',
										gap: '8px',
										alignItems: 'center',
										flexWrap: 'wrap',
									}}
								>
									{groupLabelArray}
								</Box>
							</>
						)}
					</Box>
				</Box>
			</CardStandart>
		</Box>
	)
}

export default RationCard
